.container {
  position: relative;
  width: fit-content;
}

.trigger-btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--border-input);
  background: var(--background);
  color: var(--text-body);
  text-transform: none;
  font-weight: 400;
  padding: 8px 12px;
  height: 30px;
  min-width: 90px;
  border-radius: 2px;
  font-size: 14px;
  line-height: 2.5em;
  font-family: inherit;
  cursor: pointer;
}

.trigger-btn hd-icon {
  flex-shrink: 0;
  margin-right: 8px;
}

.dropdown-content {
  position: absolute;
  top: calc(100% + 8px);
  background: var(--background);
  border: 1px solid var(--border-input);
  border-radius: 2px;
  padding: 16px 20px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 20px;
  z-index: 1000;
}

.dropdown-content.right {
  right: 0;
}

.dropdown-content.left {
  left: 0;
}

.dropdown-content .close-btn {
  position: absolute;
  top: 20px;
  right: 16px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.dropdown-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dropdown-item .item-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4em;
  margin: 0;
}

.dropdown-item label {
  padding-left: 16px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.4em;
}

.dropdown-item label:hover {
  opacity: 0.7;
}

.dropdown-item label:has(input:checked) {
  color: var(--text-links);
}

.dropdown-item label input {
  position: absolute;
  opacity: 0;
  left: -9999px;
}

.reset-btn {
  font-family: inherit;
  background: none;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  margin-top: -8px;
  margin-right: -8px;
  margin-left: auto;
  font-size: 11px;
  line-height: 1.4;
}
